import { useSyncExternalStore } from 'react'
import { JWT } from '../constants/local_storage'
import { JWT_CHANGE_EVENT, jwtStorage } from '../utils/jwtStorage'

function subscribe(onChange: () => void): () => void {
  window.addEventListener(JWT_CHANGE_EVENT, onChange)
  function handleStorage(e: StorageEvent) {
    if (e.key === null || e.key === JWT) {
      onChange()
    }
  }
  window.addEventListener('storage', handleStorage)
  return () => {
    window.removeEventListener(JWT_CHANGE_EVENT, onChange)
    window.removeEventListener('storage', handleStorage)
  }
}

/**
 * The stored JWT, read as external state so components stay pure.
 */
const useJwt = (): string | null =>
  useSyncExternalStore(subscribe, jwtStorage.get, jwtStorage.get)

export default useJwt
